// Imported first in index.js so the per-tab session overlay is in place
// before the redux store and redux-persist read localStorage.
import { installImpersonationOverlay } from "./impersonation";

installImpersonationOverlay();
